import Tree from './Tree';
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tree/index.js
// module id = 1127
// module chunks = 0